const state = {
  confirmCancelBookmark: null,
  deleteIndexBookmark: null,
  deleteLabelBookmark: null,
  denyDeleteBookmark: false,
  formBookmark: { action: 'update', entry: null, scope: 'list' },
  isModalVisibleBookmark: false,
  isValidBookmarkForm: false,
  promptDeleteBookmark: null,
}

export default state
